import i18n from 'i18next';
import Backend from 'i18next-http-backend';
// import Backend from 'i18next-fs-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
	// Подключение бэкенда i18next
	.use(Backend)
	// Автоматическое определение языка
	.use(LanguageDetector)
	// модуль инициализации
	.use(initReactI18next)
	.init({
		// Стандартный язык
		fallbackLng: 'el',
		supportedLngs: ['en', 'el'],
		react: {
			transSupportBasicHtmlNodes: true,
			transKeepBasicHtmlNodesFor: ['br', 'strong', 'b', 'i', 'span', 'p', 'img', 'a']
		},
		debug: false,
		// Распознавание и кэширование языковых кук
		detection: {
			order: ['localStorage'],
			lookupLocalStorage: 'lang',
			// order: ['queryString', 'cookie'],
			// cache: ['cookie'],
		},
		interpolation: {
			escapeValue: false,
		},
		nsSeparator: ':::',
		keySeparator: '::',
		// saveMissing: true,
		// backend: {
		// 	loadPath: '/locales/{{lng}}/translation.json',
		// 	addPath: '/locales/{{lng}}/missing.json'
		// }
	});

console.log(i18n.languages);

export default i18n;
